
export default {
  name: 'Breadcrumbs',
  props: {
    nomPage: {
      type: String,
      default: ''
    },
    nomSection: {
      type: String,
      required: true
    },
    nomSousSection: {
      type: String,
      required: true
    },
    urlPage: {
      type: String,
      default: ''
    },
    urlSection: {
      type: String,
      required: true
    },
    urlSousSection: {
      type: String,
      required: true
    }
  },
  computed: {
    cheminSousSection: function () {
      return '/' + this.$i18n.locale + '/' + this.urlSection + '/' + this.urlSousSection
    },
    cheminPage: function () {
      return this.cheminSousSection + '/' + this.urlPage
    }
  }
}
